import { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'
import { Loader2 } from 'lucide-react'
import { trackReferralUsage, validateReferralCodeWithTenant } from '@/utils/tenantReferralUtils'

const ReferralRedirect = () => {
  const { code, landingPage } = useParams<{ code: string; landingPage?: string }>()
  const navigate = useNavigate()
  const [processing, setProcessing] = useState(true)

  useEffect(() => {
    if (code) {
      handleReferralRedirect()
    }
  }, [code])

  const handleReferralRedirect = async () => {
    try {
      console.log('ReferralRedirect: Processing code:', code)
      console.log('ReferralRedirect: Full URL:', window.location.href)
      
      // Track the click immediately with landing page info
      await trackReferralUsage(code!, 'redirect_tracking', navigator.userAgent, { landingPage })
      console.log('ReferralRedirect: Tracking completed')

      // Resolve tenant slug via Edge Function (robust fallback)
      const { data: resolved, error: resolveError } = await supabase.functions.invoke('resolve-referral-tenant', {
        body: { referral_code: code }
      })

      console.log('ReferralRedirect: Resolve result:', { resolved, resolveError })

      if (resolveError || !resolved) {
        console.warn('ReferralRedirect: Could not resolve tenant, falling back to referral page')
        navigate(`/ref/${code}${landingPage ? `/${landingPage}` : ''}`)
        return
      }

      // If there's a landing page specified, redirect to the public landing page
      if (landingPage) {
        const tenantSlug = (resolved as any).tenant_slug || (resolved as any).tenant_id
        setTimeout(() => {
          console.log('ReferralRedirect: Executing landing page redirect to:', `/lp/${tenantSlug}/${landingPage}?ref=${code}`)
          navigate(`/lp/${tenantSlug}/${landingPage}?ref=${code}`)
        }, 300)
      } else {
        // No specific landing page, redirect to referral registration
        console.log('ReferralRedirect: No landing page, redirecting to referral registration')
        navigate(`/ref/${code}`)
      }
    } catch (error) {
      console.error('ReferralRedirect: Error processing redirect:', error)
      // Fallback to direct referral page
      navigate(`/ref/${code}${landingPage ? `/${landingPage}` : ''}`)
    } finally {
      setProcessing(false)
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-4 text-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <div>
          <h2 className="text-lg font-semibold mb-2">Empfehlungslink wird verarbeitet...</h2>
          <p className="text-sm text-muted-foreground">
            Sie werden in einem Moment weitergeleitet
          </p>
        </div>
      </div>
    </div>
  )
}

export default ReferralRedirect